import { Injectable, OnDestroy } from '@angular/core';
import { Subscription } from 'rxjs';
import { NotificationService, NotificationType } from './notifications.service';
import {
  MessageType,
  createCommunicationService,
} from '@xpw-packages/communication-service/dist/angular';

export interface IframeNotificationPayload {
  type: NotificationType;
  title: string;
  message: string;
  duration: number;
  placement: string;
  buttons: Array<{
    text: string;
    actions: any[];
  }>;
}
enum actionType {
  NOTIFICATION = 'NOTIFICATION',
  CLEAR_NOTIFICATIONS = 'CLEAR_NOTIFICATIONS',
}
@Injectable({
  providedIn: 'root',
})
export class IframeNotificationService implements OnDestroy {
  private subscription: Subscription | null = null;
  private isIframeMode = false;
  private iframeCommunicationService = createCommunicationService();

  constructor(private notificationService: NotificationService) {
    this.initializeIframeMode();
  }

  private initializeIframeMode(): void {
    // Check if we're in iframe mode by looking for the 'app-iframe' class on body
    
      this.subscribeToNotifications();
      console.log('IframeNotificationService initialized for iframe mode');
  }

  private subscribeToNotifications(): void {
    this.subscription = this.notificationService.notificationTemplateData$.subscribe(
      (notificationData) => {
        if (notificationData) {
          this.sendNotificationToParent(notificationData);
        } else {
          this.clearNotifications();
        }
      }
    );
  }

  private sendNotificationToParent(notificationData: any): void {
    try {
      const payload: IframeNotificationPayload = {
        type: notificationData.type,
        title: notificationData.title,
        message: notificationData.message,
        duration: notificationData.duration,
        placement: notificationData.placement,
        buttons: notificationData.buttons || [],
      };
      console.log('Notification sent to parent:', payload);
      // Send notification to parent Next.js application using communication service
      this.iframeCommunicationService.dispatchAction(actionType.NOTIFICATION, 'angular',payload);

     
    } catch (error) {
      console.error('Error sending notification to parent:', error);
    }
  }

  

  private clearNotifications(): void {
    try {
      // Send clear notification message to parent using communication service
      this.iframeCommunicationService.dispatchAction('CLEAR_NOTIFICATIONS', 'angular');

      console.log('Clear notifications message sent to parent');
    } catch (error) {
      console.error('Error clearing notifications:', error);
    }
  }

 
  ngOnDestroy(): void {
    if (this.subscription) {
      this.subscription.unsubscribe();
    }
  }
} 